// @flow

import React from "react";
import { compose } from "redux";
import { localize } from "redux-i18n";

import { ApprovalStateEnum } from "@modules/service/constants";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "@components";
import type { ApprovableContainer, ApprovalState } from "@modules/service/types";

type OwnProps = $Exact<{
  isFirstCareUser: boolean,
  data: ?ApprovableContainer<any>,
  type: string,
  name: string,
  onCancel: () => void,
  onSubmit: () => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class ApprovableDisableModal extends React.Component<Props> {
  submitModal = (prop: *) => {
    this.props.onSubmit();
  };

  get nextState(): string {
    const _data = this.props.data?.active || this.props.data?.content || {};

    if (_data.details) {
      return (_data.details || {}).isActive ? "DISABLE" : "ENABLE";
    }
    return _data.isActive ? "DISABLE" : "ENABLE";
  }

  get status(): ApprovalState {
    return (this.props.data || {}).approvalState;
  }

  get questionText(): string {
    return this.props.t(`APPROVABLE_${this.nextState}_SETUP_QUESTION`, {
      approvableType: this.props.type,
      approvableName: this.props.name,
    });
  }

  get warningText(): string {
    return this.props.t(`APPROVABLE_${this.nextState}_SETUP_WARNING`);
  }

  get submitText(): string {
    if (this.withApprovalProcess === false) {
      return this.props.t(this.nextState);
    }

    if (this.props.isFirstCareUser) {
      if (this.status !== ApprovalStateEnum.ACTIVE_ONLY) {
        return this.props.t("OK");
      }
      return this.props.t(this.nextState);
    }
    return this.props.t(this.nextState);
  }
  get withApprovalProcess() {
    // The approval process apply when the data object
    // contains the “approvalState” property
    return !!(this.props.data && this.props.data.approvalState);
  }

  render() {
    return (
      <Modal className="modal-small">
        <ModalHeader className="d-flex justify-content-between" toggle={this.props.onCancel}>
          {this.props.t(`APPROVABLE_${this.nextState}_SETUP_TITLE`, {
            approvableType: this.props.type,
            approvableName: this.props.name,
          })}
        </ModalHeader>
        <ModalBody className="d-flex flex-column justify-content-start align-content-center">
          {this.props.isFirstCareUser &&
          this.status !== ApprovalStateEnum.ACTIVE_ONLY &&
          this.withApprovalProcess ? (
            <p className="text-danger">{this.warningText}</p>
          ) : (
            <React.Fragment>
              <p className="text-greyish-brown">{this.questionText}</p>
            </React.Fragment>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onCancel}>
            {this.props.t("CANCEL")}
          </Button>
          <Button
            materialIcon={this.props.data?.content?.isActive ? "toggle_off" : "toggle_on"}
            onClick={this.submitModal}
          >
            {this.submitText}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default compose(localize())(ApprovableDisableModal);
